import {Component, Input, OnInit} from '@angular/core';
import {NavigationComponentService} from '@app/services/navigation-component.service';
import {Observable} from 'rxjs';
import {DcpLinkModel} from '@app/model/dcp-link-model';
import {NgbDropdown} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'dcp-user-menu-links',
  templateUrl: './user-menu-links.component.html',
  styleUrls: ['./user-menu-links.component.scss']
})
export class UserMenuLinksComponent implements OnInit {

  @Input() dropdown: NgbDropdown;
  navNodes$: Observable<Map<string, Observable<DcpLinkModel>[]>>;
  navId: string = 'UserMenuNavigationComponent';

  constructor(public navigationComponentService: NavigationComponentService) {
  }

  ngOnInit() {
    this.navNodes$ = this.navigationComponentService.fetchComponentData(this.navId);
  }
}
